import { render, staticRenderFns } from "./FollowPanel.vue?vue&type=template&id=f1bbf63a&scoped=true"
import script from "./FollowPanel.vue?vue&type=script&lang=ts"
export * from "./FollowPanel.vue?vue&type=script&lang=ts"
import style0 from "./FollowPanel.vue?vue&type=style&index=0&id=f1bbf63a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bbf63a",
  null
  
)

export default component.exports